import { render, staticRenderFns } from "./CreateShortcut.vue?vue&type=template&id=ee7bea88"
import script from "./CreateShortcut.vue?vue&type=script&lang=js"
export * from "./CreateShortcut.vue?vue&type=script&lang=js"
import style0 from "./CreateShortcut.vue?vue&type=style&index=0&id=ee7bea88&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports